module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.2ca27783.ttf";